"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiListSubheaderOverrides = void 0;
var createMuiListSubheaderOverrides = function (_a) {
    var spacing = _a.spacing;
    return ({
        gutters: {
            paddingLeft: spacing(2),
            paddingRight: spacing(2),
        },
    });
};
exports.createMuiListSubheaderOverrides = createMuiListSubheaderOverrides;
//# sourceMappingURL=MuiListSubheader.js.map